/**
 * The birth-date rule, in the browser's own terms.
 *
 * The same numbers the API enforces (`common/schemas.validate_birth_date`):
 * nothing in the future, nothing more than two hundred years ago, and nobody
 * under eighteen. Here they become the date picker's own bounds, so a day that
 * would be refused cannot be reached in the first place — the server still
 * refuses it, because a browser is not a place to keep a rule.
 *
 * `MINIMUM_AGE` must match `MINIMUM_AGE` in the backend's `common/schemas.py`.
 * Out of step the picker either offers days the API rejects, or hides days it
 * would have taken.
 */
export const MINIMUM_AGE = 18;
export const MAXIMUM_AGE = 200;

/** The same day, that many years back, as `YYYY-MM-DD`. */
function yearsAgo(years: number): string {
  const today = new Date();
  const then = new Date(today.getFullYear() - years, today.getMonth(), today.getDate());
  return then.toISOString().slice(0, 10);
}

/** The oldest a date of birth may be. */
export const birthDateMin = () => yearsAgo(MAXIMUM_AGE);
/** The most recent: someone turning eighteen today. */
export const birthDateMax = () => yearsAgo(MINIMUM_AGE);
/** For a day that is written down after the fact rather than scheduled. */
export const today = () => yearsAgo(0);
